import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "react-bootstrap";
import "../../../../style/addmaterial.css";
import "../../../../style/dashboardcentralhubstyle.css";
import "../../../../style/customresponsivefile.css";
import { apiAxios } from "../../../../utils/apiAxios";
import { Profile } from "../Interfaces/Profile";
import { Role } from "../Interfaces/Role";
import {User} from "../Interfaces/User"


const AddUsers: React.FC = () => {
  const [profile, setProfile] = useState<Profile>({
    name: "",
    email: "",
    role: "",
    password: "",
    confirmPassword: "",
    userID: 0,
    roleID: 0,
    mobileNo: ""
  });

  const [users, setUsers] = useState<User[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [pincodeError, setPincodeError] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const formRef = useRef<HTMLDivElement | null>(null);
const isDesigner = roles.find(
  (r) => String(r.roleID) === String(profile.role)
)?.roleName === "Designer";
  useEffect(() => {
    fetchUsers();
    fetchRoles();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await apiAxios.get(`${API_BASE}/Users/GetAdminUser`);
      const mappedUsers = response.data.map((u: any) => ({
        id: u.userID,
        name: u.name,
        email: u.email,
        mobileNo: u.mobileNo,
        roleName: u.roleName,
        //roleID: u.roleID,
        roleID: String(u.roleID), 
        userID: u.userID,
        isActive: u.isActive
      }));
      setUsers(mappedUsers);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await apiAxios.get(`${API_BASE}/Users/GetRoles`);

      const filteredRoles = response.data.filter(
        (role: Role) => role.isCentralHub && role.roleName !== "Delivery"
      );

      setRoles(filteredRoles);
    } catch (error) {
      console.error("Failed to fetch roles:", error);
      toast.error("Failed to fetch roles.");
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Required fields check
    if (
      !profile.name ||
      !profile.email ||
      !profile.role
    ) {
      toast.error("Please fill all required fields.");
      return;
    }
    if (isDesigner) {
      if (!profile.mobileNo || profile.mobileNo.length !== 10) {
        toast.error("Valid 10-digit mobile number is required for Designer");
        return;
      }
    }
    const passwordPattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!isEditMode || profile.password) {

      if (!profile.password) {
        toast.error("Password is required");
        return;
      }

      if (!passwordPattern.test(profile.password)) {
        toast.error(
          "Password must contain at least 8 characters, including uppercase, lowercase, number and special character."
        );
        return;
      }

      // Confirm password match
      if (profile.password !== profile.confirmPassword) {
        toast.error("Password and Confirm Password do not match");
        return;
      }
    }
    // Email validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(profile.email)) {
      toast.error("Invalid Email Address.");
      return;
    }

    setIsSubmitting(true);

    try {
      let payload: any = {
        name: profile.name,
        email: profile.email,
        roleID: profile.role,
        isApproved: true,
        userID: editId || 0,
        mobileNo: isDesigner ? profile.mobileNo : null
      };

      // Only send password if adding OR user typed password in edit
      if (!isEditMode || profile.password) {
        payload.passwordHash = profile.password;
        payload.confirmPassword = profile.confirmPassword;
      }

      if (isEditMode && editId) {

        const response = await apiAxios.put(
          `${API_BASE}/Users/UpdateUser/${editId}`,
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.status === 200) {
          toast.success("User updated successfully!");
          resetForm();
          fetchUsers();
        } else {
          toast.error("Failed to update user.");
        }
      } else {
        // ADD User
        const response = await apiAxios.post(
          `${API_BASE}/Users/CreateUser`,
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.status === 201 || response.statusText === "Created") {
          // toast.success(response.data.status);
          toast.success("User add successfully!");
          resetForm();
          fetchUsers();
        }
      }
    } catch (error: any) {

      if (error.response) {

        const { status, data } = error.response;

        if (status === 409) {
          toast.warning(data.message || "User already exists");
        }
        else if (data?.errors) {
          data.errors.forEach((err: string) => toast.error(err));
        }
        else {
          toast.error(data.message || "Something went wrong");
        }

      } else {
        toast.error("Network error. Please try again.");
      }


    } finally {
      setIsSubmitting(false);
    }
  };



  const resetForm = () => {
    setProfile({
      name: "",
      email: "",
      role: "",
      password: "",
      confirmPassword: "",
      userID: 0,
      roleID: 0,
      mobileNo: ""
    });
    setIsEditMode(false);
    setEditId(null);
    setPincodeError("");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleEdit = (user: User) => {
    setProfile({
      name: user.name,
      email: user.email,
      //role: user.roleID || "",
      role: String(user.roleID || ""),
      password: "",
      confirmPassword: "",
      mobileNo: user.mobileNo || ""
    });
    setEditId(user.userID || null);
    setIsEditMode(true);

  };
  useEffect(() => {
    if (editId && formRef.current) {
      const container = formRef.current.closest(".main-content");

      if (container) {
        container.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }
  }, [editId]);

  const handleCancel = () => {
    setIsEditMode(false);
    setEditId(null);
    resetForm();
  };

  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    if (deleteId === null) return;

    try {
      const response = await apiAxios.delete(
        `${API_BASE}/Users/DeleteUser/${deleteId}`
      );

      const data = response.data;

      if (data.isSuccess) {
        toast.success(data.status);
        fetchUsers();
      } else {
        toast.warning(data.status);
      }

    } catch (error: any) {

      if (error.response) {
        // API returned error like 409 / 404
        const data = error.response.data;

        toast.warning(data.status || data.message);
      } else {
        // real network error
        toast.error("Network error. Please try again.");
      }

    } finally {
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };
  return (
    <div >
      <h4 className="mb-4">
        {isEditMode ? (
          <i className=" me-2" ></i>
        ) : (
          <i className=" me-2"></i>
        )}
        {isEditMode ? "Edit User" : "Add New User"}
      </h4>

      <div ref={formRef} className="premium-card ">

        <form onSubmit={handleSubmit} className="mt-1">
          <div className="row">

            <div className="col-md-6 col-lg-6 col-12 mb-3">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text bg-light">
                  <i className="bi bi-person"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your name"
                  value={profile.name}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      setProfile({ ...profile, name: value });
                    }
                  }}
                  required
                />
              </div>
            </div>

            {/* Email */}
            <div className="col-md-6 col-lg-6 col-12 mb-3">
              <label className="form-label">Email <span className="text-danger">*</span></label>
              <div className="input-group">
                <span className="input-group-text bg-light">
                  <i className="bi bi-envelope"></i>
                </span>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={profile.email}
                  onChange={(e) =>
                    setProfile({ ...profile, email: e.target.value })
                  }
                  required
                />
              </div>
              {profile.email.length > 0 &&
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(profile.email) && (
                  <div className="text-danger mt-1">
                    Please enter a valid email address.
                  </div>
                )}
            </div>


            {/* Role */}
            <div className="col-md-6 col-lg-6 col-12 mb-3">
              <label className="form-label">
                Role <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                value={profile.role}
                onChange={(e) => {
                  const value = e.target.value;

                  const selected = roles.find(r => String(r.roleID) === value);

                  setProfile({
                    ...profile,
                    role: value,
                    mobileNo: selected?.roleName === "Designer" ? profile.mobileNo : ""
                  });
                }}
                required
              >
                <option value="">Select Role</option>
                {roles.map(role => (
                  <option key={role.roleID} value={role.roleID}>
                    {role.roleName}
                  </option>
                ))}
              </select>
            </div>
            {/* Mobile Number - Only for Designer */}
            {isDesigner && (
              <div className="col-md-6 col-lg-6 col-12 mb-3">
                <label className="form-label">
                  Mobile Number <span className="text-danger">*</span>
                </label>

                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="bi bi-telephone"></i>
                  </span>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter mobile number"
                    value={profile.mobileNo}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setProfile({ ...profile, mobileNo: value });
                      }
                    }}
                    required={isDesigner}
                  />
                </div>
              </div>
            )}

            <div className="col-md-6 col-lg-6 col-12 mb-3 ">
              <label className="form-label">Password <span className="text-danger">*</span></label>
              <div className="input-group position-relative">
                <span className="input-group-text bg-light">
                  <i className="bi bi-shield-lock"></i>
                </span>

                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter your password"
                  value={profile.password}
                  onChange={(e) =>
                    setProfile({ ...profile, password: e.target.value })
                  }
                  required={!isEditMode}
                />

                {/* Eye icon */}
                <span
                  className="position-absolute-eye-icon"

                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
                </span>
              </div>


            </div>
            <div className="col-md-6 col-lg-6 col-12 mb-3 ">
              <label className="form-label">Confirm Password <span className="text-danger">*</span></label>
              <div className="input-group position-relative">
                <span className="input-group-text bg-light">
                  <i className="bi bi-shield-lock"></i>
                </span>

                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control pe-5"
                  placeholder="Enter your confirm password"
                  value={profile.confirmPassword}
                  onChange={(e) =>
                    setProfile({ ...profile, confirmPassword: e.target.value })
                  }
                  required={!isEditMode}
                />

                {/* Eye Icon */}
                <span
                  className="position-absolute-eye-icon"

                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i
                    className={`bi ${showConfirmPassword ? "bi-eye" : "bi-eye-slash "
                      }`}
                  ></i>
                </span>
              </div>


            </div>

          </div>

          <div className="row mt-2">
            <div className="col-md-12 d-flex  py-3">
              <button
                type="submit"
                className="btn btn-primary mt-1"
                disabled={isSubmitting}
              >
                {isEditMode ? "Update User" : "Add User"}
              </button>

              <button
                type="button"
                className="btn btn-secondary mt-1 ms-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>

        </form>
      </div>
      {/* Users List */}
      <div className="premium-card mt-3">

        <h5 className="mb-3">
          Users List
        </h5>

        <table className="table align-middle add-user-custom-table  mb-0 custom-material-table2   mt-3">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th style={{ width: "150px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              users.map((user, index) => (
                <tr key={index}>

                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.roleName}</td>
                  <td>
                    <span className={`badge ${user.isActive ? "bg-success" : "bg-danger"}`}>
                      {user.isActive ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <div className="action-btn delete custom-edit-icon"

                        onClick={() => handleEdit(user)}
                      >
                        <i className="bi bi-pencil-square" title="Edit"></i>
                      </div>
                      {user.isActive && (
                        <div
                          className="action-btn delete custom-edit-icon"
                          onClick={() => confirmDelete(user.userID!)}
                        >
                          <i className="bi bi-trash" title="Delete"></i>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center">
                  No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Delete Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        dialogClassName="custom-top-modal"
      >
        <Modal.Body className="text-center">
          <p className="fs-6">

            Are you sure you want to delete this user?
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button type="button" className="btn py-2 px-3 btn-primary" onClick={handleDelete}>
            Yes
          </button>
          <button type="button" className="btn py-2 px-3 btn-secondary  mx-2"
            onClick={() => setShowDeleteModal(false)}
          >
            No
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddUsers;
